import { css, pulse, styled } from '@showroomjs/ui';
import * as React from 'react';
import { Article } from './article';
import { Div as Base } from './base';
import { DetailsPageContainer } from './details-page-container';
import { mdxComponents } from './mdx-components';
const { h1: Heading, p: P, h2: Subheading } = mdxComponents;
export const PageFallback = (props) => {
    return (React.createElement(DetailsPageContainer, { title: props.title },
        React.createElement(Article, null,
            React.createElement(Heading, { className: pulseCs() }, props.title || (React.createElement(Div, { css: {
                    width: '50%',
                    height: '3.75rem',
                } }))),
            React.createElement(Text, { css: {
                    width: '70%',
                } }),
            React.createElement(CodeBlockSkeleton, null),
            React.createElement(Text, { css: {
                    width: '40%',
                } }),
            React.createElement(Subheading, null,
                React.createElement(Div, { css: {
                        width: '30%',
                        height: '2.25rem',
                    }, className: pulseCs() })),
            React.createElement(Text, null),
            React.createElement(Text, null),
            React.createElement(Text, { css: {
                    width: '50%',
                } }),
            React.createElement(Subheading, null,
                React.createElement(Div, { css: {
                        width: '40%',
                        height: '2.25rem',
                    }, className: pulseCs() })),
            React.createElement(Text, { css: {
                    width: '70%',
                } }),
            React.createElement(CodeBlockSkeleton, null),
            React.createElement(Text, { css: {
                    width: '40%',
                } }))));
};
const pulseCs = css({
    animation: `${pulse} 2s cubic-bezier(0.4, 0, 0.6, 1) infinite`,
});
const Div = styled('div', {
    backgroundColor: '$gray-200',
});
const Text = styled(P, {
    height: '1rem',
    backgroundColor: '$gray-200',
    animation: `${pulse} 2s cubic-bezier(0.4, 0, 0.6, 1) infinite`,
});
const CodeBlockSkeleton = () => {
    return (React.createElement(Base, { css: {
            marginTop: '$4',
            marginBottom: '$8',
        } },
        React.createElement(Base, { css: {
                minHeight: 48,
                border: '1px solid',
                borderColor: '$gray-300',
                padding: '$2',
            } },
            React.createElement(Base, { css: {
                    display: 'flex',
                    gap: '$4',
                    justifyContent: 'center',
                } },
                React.createElement(Div, { css: {
                        width: 100,
                        height: '2rem',
                    }, className: pulseCs() }),
                React.createElement(Div, { css: {
                        width: 100,
                        height: '2rem',
                    }, className: pulseCs() })))));
};
//# sourceMappingURL=page-fallback.js.map